import { FC } from 'react';
import { useRouter } from 'next/router';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { IntroduceIcon1, IntroduceIcon2, IntroduceIcon3 } from '@/components/TradeIn/svg';
import { getIsLogin } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';

const Introduce: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('tradein.introduce');
    const isLogin = getIsLogin();
    const router = useRouter();

    const list = [
        {
            key: 1,
            icon: <IntroduceIcon1 />,
            name: t('introduce_step1_name'),
            desc: t('introduce_step1_desc'),
        },
        {
            key: 2,
            icon: <IntroduceIcon2 />,
            name: t('introduce_step2_name'),
            desc: t('introduce_step2_desc'),
        },
        {
            key: 3,
            icon: <IntroduceIcon3 />,
            name: t('introduce_step3_name'),
            desc: t('introduce_step3_desc'),
        },
    ];

    // 要求第一个点击跳转表单
    const handleNextPage = (key: number) => {
        if (key !== 1) return;
        if (isLogin) {
            router.push('/trade-in-online');
        } else {
            signupCookie?.({
                sector_name: t('introduce_title'),
                entry_position: 3,
            });
            router.push(`/login?redirect=${encodeURIComponent(`/${locale}/trade-in`)}`);
        }
    };

    return (
        <div className={styled.Introduce}>
            <div className="tradein-spaec"></div>
            <p className="introduce_subtitle">{t('introduce_subtitle')}</p>
            <div className="tradein-spaec"></div>
            <div className="ef-container">
                <h6 className="introduce_title">{t('introduce_title')}</h6>
                <ul className="introduce_list">
                    {list.map((item) => (
                        <li key={item.key} className="introduce_item" onClick={() => handleNextPage(item.key)}>
                            <span className="introduce_item_step">
                                {t('introduce_step')}
                                {item.key}
                            </span>
                            {item.icon}
                            <p className="introduce_item_name">{item.name}</p>
                            <p className="introduce_item_desc">{item.desc}</p>
                        </li>
                    ))}
                </ul>
                <p className="introduce_tips">
                    {t.rich('introduce_tips', {
                        link: (text: string) => <a href="#trade-in-tc">{text}</a>,
                    })}
                </p>
            </div>
        </div>
    );
};

export default Introduce;
